/* eslint-disable */
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subject, takeUntil } from "rxjs";
import { CreditCard, CreditCardValidators } from "angular-cc-library";

export class CreditCardData {
    flag: string;

    holder: string;

    number: string;

    exp: string;

    cvc: string;

    valid: boolean;
}

@Component({
    selector: "credit-card",
    templateUrl: "./credit-card.component.html",
})
export class CreditCardComponent implements OnChanges, OnInit, OnDestroy {
    form: FormGroup;

    protected _unsubscribeAll: Subject<any>;

    @Output()
    cardDataChanged: EventEmitter<CreditCardData>;

    @Input()
    cardData: CreditCardData;

    constructor(private _formBuilder: FormBuilder) {
        this._unsubscribeAll = new Subject();
        this.cardDataChanged = new EventEmitter<CreditCardData>();
    }

    ngOnChanges(): void {
        if (this.form && !this.cardData) {
            this.form.reset();
            this.form.markAllAsTouched();
        }
    }

    ngOnInit(): void {
        this.form = this._formBuilder.group({
            holder: [null, [Validators.required]],
            card: this._formBuilder.group({
                number: [null, CreditCardValidators.validateCCNumber],
                exp: [null, CreditCardValidators.validateExpDate],
                cvc: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(4)]],
            }),
        });
        this.form.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            let data = this.form.getRawValue();
            const cardType = CreditCard.cardType(data.number) || "unknown";
            this.cardDataChanged.emit({
                flag: cardType,
                number: data.card.number,
                exp: data.card.exp,
                holder: data.holder,
                cvc: data.card.cvc,
                valid: this.form.valid,
            });
        });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    get cardForm() {
        return this.form.get("card") as FormGroup;
    }
}
